import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    margin: 0,
    '& * .MuiGrid-spacing-xs-3': {
      margin: 0,
    },
    '& .swiper-button-disabled': {
      color: theme.palette.common.black,
      transition: 'none',
    },
  },
  descInputContainer: {
    marginBottom: '-15px',
  },
  imageContainer: {
    alignItems: 'center',
    height: 240,
    display: 'flex',
    maxWidth: '290px',
    position: 'relative',
    overflow: 'hidden',
  },
  cardMedia: {
    backgroundColor: theme.palette.blue.lightest,
    borderRadius: theme.shape.borderRadius,
    height: '100%',
    width: '100%',
  },
  input: {
    display: 'none',
    width: '40%',
  },
  inputLabelContainer: {
    backgroundColor: theme.palette.blue.lightest,
    borderRadius: theme.shape.borderRadius,
    position: 'absolute',
    top: 0,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(0.5),
    marginTop: theme.spacing(0.5),
  },
  iconLabelContainer: {
    marginLeft: theme.spacing(0.5),
    marginTop: theme.spacing(0.5),
    position: 'absolute',
    top: 0,
  },
  iconLabel: {
    backgroundColor: theme.palette.common.white,
    zIndex: 5,
    '&:hover': {
      backgroundColor: theme.palette.blue.lightest,
    },
  },
  inputLabel: {
    marginLeft: theme.spacing(1),
    fontWeight: 300,
    fontSize: 18,
    lineHeight: '21.09px',
    textAlign: 'center',
  },
  textfieldContainer: {
    height: 240,
    width: '100%',
    '& div': {
      height: '100%',
    },
  },
  buttonImageContainer: {
    position: 'fixed',
    margin: 8,
    width: 100,
    height: 100,
    zIndex: 10,
    '& *': { display: 'none' },
    '&:hover': {
      display: 'flex',
      justifyContent: 'space-evenly',
      alignItems: 'center',
      backgroundColor: '#00000030',
      '& *': { display: 'block', color: theme.palette.common.white },
    },
  },
  sliderImage: {
    position: 'relative',
    margin: 8,
    height: 100,
    width: 100,
    minWidth: 100,
    zIndex: 1,
    borderRadius: theme.shape.borderRadius,
  },
  sliderButtonBox: {
    height: '100%',
    paddingBottom: theme.spacing(1),
    paddingTop: theme.spacing(1),
  },
  sliderButton: {
    border: 'none',
    borderRadius: '10px',
    color: theme.palette.primary.main,
    height: '100%',
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    maxWidth: 40,
    minWidth: 40,
  },
  sliderButtonIcon: {
    color: theme.palette.primary.main,
    height: 35,
    width: 18,
  },
  iconButton: {
    height: 50,
  },
}));
